import React from "react";
import { useTranslation } from "react-i18next";
import { ModalFooter } from "reactstrap";
import { useSnapshot } from "valtio";
import { mutate } from "swr";
import { toast } from "react-toastify";

import store from "./store";
import { store as userStore } from "@components/VerticalLayout/store";
import { useFetchGlobal } from "../../../../../api/hooks";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";

type ModalFooterType = {
    setDataIsUpdated: Function;
    isConfigurationCashManagementClicked: boolean;
    setIsConfigurationCashManagementClicked: Function;
    rowData: any;
};

export function Footer({
    isConfigurationCashManagementClicked,
    setIsConfigurationCashManagementClicked,
    setDataIsUpdated,
    rowData,
}: ModalFooterType) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();
    const { userID, franchiseID, shopID, oneShop } = useSnapshot(userStore);
    const {
        acceptedDenomination,
        cushFund,
        cashManagementState,
        collectionAlert,
        loadingAlert,
        emptyAlert,
    } = useSnapshot(store);

    async function handleValidateButtonClickEvent() {
        let userId: number;
        let shopId: string;
        let franchiseId: string;

        if (oneShop) {
            franchiseId = franchiseID;
            shopId = shopID.toString();
            userId = userID;
        } else {
            userId = userID;
            shopId = rowData.shopId;
            franchiseId = franchiseID;
        }

        let apiUrl = `${process.env.REACT_APP_API_V2_URL}/settings/application/pos/cashManagement/setting`;
        let savedData = {
            userId: userId,
            shopId: shopId,
            franchiseId: franchiseId,
            appId: "POS",
            appId_children: rowData.appId,
            peripheralId: rowData.peripheralId,
            data: {
                accepted_denomination: acceptedDenomination,
                collection_alert: collectionAlert,
                empty_coin_alert: emptyAlert,
                cash_Fund: cushFund,
                coin_loading_alert: loadingAlert,
                coin_status: cashManagementState,
            },
        };
        try {
            const data: any = await fetchGlobal(apiUrl, {
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(savedData),
                method: "POST",
            });
            mutate(apiUrl, data);
            if (data.error) {
                throw Error(`${t("Error while saving selection!")}`);
            }
            toast.success(`${t("Registration successfully")}!`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        } catch (e: any) {
            toast.error(`${"There's an error"}!`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
    }

    return (
        <ModalFooter>
            <CustomSecondaryColorButton
                outline
                rounded
                className="mr-2"
                variant="danger"
                onClick={() => {
                    setIsConfigurationCashManagementClicked(
                        !isConfigurationCashManagementClicked
                    );
                }}
            >
                <span>{t("Cancel")}</span>
            </CustomSecondaryColorButton>
            <CustomMainColorButton
                rounded
                variant="primary"
                onClick={() => {
                    handleValidateButtonClickEvent();
                }}
            >
                {t("Validate")}
            </CustomMainColorButton>
        </ModalFooter>
    );
}
